import { useEffect, useState } from "react";
import Nav from "../components/Nav";
import Footer from "../components/Footer";
import SEO from "../components/SEO";
import PageShell from "../components/marketing/PageShell";
import PageHero from "../components/marketing/PageHero";
import CTAStrip from "../components/marketing/CTAStrip";
import ServiceDetailCard from "../components/marketing/ServiceDetailCard";
import { fetchPublicServices } from "../lib/servicesApi";

export default function ServicesPage() {
  const [services, setServices] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    fetchPublicServices()
      .then(setServices)
      .catch(() => setError(true));
  }, []);

  return (
    <PageShell testid="page-services">
      <SEO
        title="Services"
        description="Every BRep service in one place — from a single Lift Review to a full Custom Training Programme. Pay per service, delivered by qualified coaches."
        path="/services"
      />
      <Nav />
      <PageHero
        eyebrow="Services"
        title="Buy only the help"
        titleAccent="you need."
        subtitle="Expert services, à la carte. Pick the one that moves the needle for you — pay per service, delivered by qualified coaches."
      />
      <section className="px-6 md:px-12 py-16 md:py-24">
        <div className="max-w-[1600px] mx-auto" data-testid="services-list">
          {services === null && !error && (
            <div className="text-white/40 text-sm py-16" data-testid="services-loading">Loading services…</div>
          )}
          {error && (
            <div className="text-white/40 text-sm py-16" data-testid="services-error">
              Couldn't load services. Please refresh.
            </div>
          )}
          {services && (
            <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-0">
              {services.map((s, i) => (
                <ServiceDetailCard key={s.id} service={s} index={i} />
              ))}
            </div>
          )}
        </div>
        <p className="mt-10 text-white/40 text-sm max-w-2xl">
          Every service is delivered by a qualified coach — never AI-only. Book in the BRep app.
        </p>
      </section>
      <CTAStrip
        title="Pick your service."
        subtitle="Download the app to book, or explore who's coaching."
        primary={{ to: "/download", label: "Download App" }}
        secondary={{ to: "/coaches", label: "Find a Coach" }}
      />
      <Footer />
    </PageShell>
  );
}
